import { renderHTML } from '~/src/common/utils/html';

import AddressField from '../../field/address/Component';
import { PropsFromInputs } from '../../types';

import { Container, Inner, SubTitle, Title } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title, text, background }: Props) => {
  return (
    <Container $background={background}>
      <Inner>
        <Title>{title}</Title>
        <SubTitle>{renderHTML(text)}</SubTitle>
        <AddressField />
      </Inner>
    </Container>
  );
};
